import React from 'react';
import { Flipped } from 'react-flip-toolkit';

import { css } from '@atlaskit/css';

import { expValEquals } from '@confluence/feature-experiments';

import { MAX_GROUP_SIZE } from '../presenceUtils.ts';

const wrapperStyles = css({
	position: 'relative',
});

const animations = {
	slideInFromTop: (element: HTMLElement, duration = 300) => {
		element.style.transform = 'translateY(-20px)';
		element.style.opacity = '0';

		return element.animate(
			[
				{ transform: 'translateY(-20px)', opacity: 0 },
				{ transform: 'translateY(0)', opacity: 1 },
			],
			{ duration, easing: 'cubic-bezier(.2, 0, 0, 1)', fill: 'forwards' },
		);
	},

	slideOutToBottom: (element: HTMLElement, duration = 250) => {
		return element.animate(
			[
				{ transform: 'translateY(0)', opacity: 1 },
				{ transform: 'translateY(20px)', opacity: 0 },
			],
			{ duration, easing: 'ease-in' },
		);
	},
};

export const FlippedAnimationsWrapper = ({
	children,
	flipId,
	index,
}: {
	children: React.ReactNode;
	flipId: string | number;
	index?: number;
}) => {
	const onTileAppear = (element: HTMLElement) => {
		// Add stagger delay based on index so each avatar animates separately
		const delay = (index ?? 0) * 50;
		const animation = animations.slideInFromTop(element, 400);
		const onFinish = () => {
			element.style.transform = '';
			element.style.opacity = '';
			animation.removeEventListener('finish', onFinish);
		};
		animation.addEventListener('finish', onFinish);

		// Apply delay by pausing animation and starting after delay
		if (delay > 0) {
			animation.pause();
			setTimeout(() => {
				animation.play();
			}, delay);
		}
	};

	const onTileExit = (element: HTMLElement, _: number, removeElement: () => void) => {
		animations.slideOutToBottom(element).addEventListener('finish', removeElement);
	};
	if (expValEquals('cc-motion-survey-experiment', 'cohort', 'experiment')) {
		const zIndex = MAX_GROUP_SIZE - (index ?? MAX_GROUP_SIZE);
		return (
			<Flipped flipId={flipId} onAppear={onTileAppear} onExit={onTileExit}>
				{/* eslint-disable-next-line  @atlaskit/ui-styling-standard/enforce-style-prop -- zIndex is dynamic based on avatar index */}
				<div css={wrapperStyles} style={{ zIndex }}>
					{children}
				</div>
			</Flipped>
		);
	}
	return <>{children}</>;
};
